import '../wrapper/header/headerDash.css';
import '../wrapper/header/header.css';
import {useState,useEffect,useRef} from 'react';
import { Link,useLocation} from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';

function UserMenu({ open, doLogout, closeMenu,reloadusercontext,handleShowModal1,handleShowModal2 }) {
    const location = useLocation();

    return (
        <>
            <Collapse in={open}>

                <div id="collapse-menu" className={`${location.pathname === '/dashboard/' ? 'black-menu' : ''}`}>
                    <div className='menu-container'>
			{(true || location.pathname === '/' || location.pathname === '/dashboard/') ?<>
                        <div>
                            <ul>
                                <li className={location.pathname==='/profile/' ? 'selected':''}><Link to="/profile/" onClick={()=>{closeMenu();}}>Il mio account</Link></li>
                                <li className={location.pathname==='' ?'selected':''}><span onClick={()=>{handleShowModal1('userLogout');}}>Esci</span></li>
                            </ul>
                        </div>
			</>:<>
                        <div>
                            <ul>
                                <li className={location.pathname==='/profile/' ? 'selected':''}><Link to="/profile/" onClick={()=>{closeMenu();}}>Il mio account</Link></li>
                                <li className={location.pathname==='/my-products/' ? 'selected':''}><Link to="/my-products/" onClick={()=>{closeMenu();}}>I miei acquisti</Link></li>
                                <li className={location.pathname==='/profile/preferences/' ?'selected':''} onClick={()=>{closeMenu();}}><Link to="/profile/preferences/">Preferenze</Link></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li className={location.pathname==='' ?'selected':''}><span onClick={()=>{closeMenu();handleShowModal2('activateProduct');}}>Attiva prodotto</span></li>
                                <li className={location.pathname==='/help-center/' ?'selected':''}><Link to="/help-center" onClick={()=>{closeMenu();}}>Help Center</Link></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li className={location.pathname==='/profile/change-password/' ?'selected':''}><Link to="/profile/change-password/" onClick={()=>{closeMenu();}}>Cambio password</Link></li>
                                <li className={location.pathname==='' ?'selected':''}><span onClick={()=>{handleShowModal1('userLogout');}}>Esci</span></li>
                            </ul>
                        </div>
			</>}
                    </div>
                </div>
            </Collapse>

        </>
    );
};

export default UserMenu;
